import { createFileRoute, Outlet } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';

// P2-02 → P2-01: TanStack's flat file convention makes `groups.$id.tsx` the PARENT of
// `groups.$id.edit.tsx`. While this rendered the details component directly, the matched edit
// child had nowhere to mount and the details page stayed on screen — so update was unreachable.
// A layout that renders an `<Outlet />` is what `users.$id.$tenantId.tsx` has always done.
export const Route = createFileRoute('/_dashboard/groups/$id')({
  beforeLoad: requireRoute('/groups/$id'),
  component: Outlet,
});
